import { createContext, useContext, ReactNode } from 'react'

interface FacebookContextType {
    purchaseFb: (data: FacebookEvents.Purchase) => void
}

const FacebookContext = createContext<FacebookContextType | undefined>(undefined)

export const FacebookProvider = ({ children }: { children: ReactNode }) => {

    const purchaseFb = (data: FacebookEvents.Purchase) => {
        if (typeof window !== 'undefined' && (window as any).fbq) {
            (window as any).fbq('track', 'Purchase', {
                value: data.value,
                currency: data.currency
            }, { eventID: data.eventID });
        }
    }

    return (
        <FacebookContext.Provider value={{ purchaseFb }}>
            {children}
        </FacebookContext.Provider>
    )
}

export const useFacebook = (): FacebookContextType => {
    const context = useContext(FacebookContext)
    if (!context) {
        throw new Error('useFacebook deve ser usado dentro de um FacebookProvider')
    }
    return context
}